// EXACT testimonials - Do not modify the text content

export const testimonials = [
  {
    id: 1,
    headline: "Voitech Solutions are a reliable IT solution engineering who uphold professionalism",
    body: "The Voitech Brand is well appreciated in their work process and results for each project undertaken",
    name: "SAMUEL OTAI",
    title: "Managing Director, GTiPay",
    company: "GTiPay",
    logo: null // Will try to fetch online
  },
  {
    id: 2,
    headline: "With Voitech on a project i am restassured the project at hand will be successful",
    body: "For the last 5 years, Voitech Solutions is our service provider supporting our Voice System with the Ericsson BP250 on an annual service level agreement basis. There excellent service delivery has enabled them be our preferred service provider for this period.",
    name: "SENTAMU DENIS",
    title: "Information Technology Manager, International Medical Group",
    company: "International Medical Group",
    logo: null
  },
  {
    id: 3,
    headline: "Voitech Solutions is a technically competent, high quality, value driven and professional IT firm",
    body: "Voitech team listens to our challenges and then designs a solution to address that challenge. This virtue in addition to their localization resources drive in all their project precedent and the value of localisation in the ICT service industry",
    name: "FRED BBAALE",
    title: "Director ICT, Parliament of Uganda",
    company: "Parliament of Uganda",
    logo: null
  },
  {
    id: 4,
    headline: "Voitech Solutions have the technical know-how and dedicated resources to execute the required tasks",
    body: "Over the past 15 years, our company has been working with Voitech solutions on numerous projects including the supply, installation and support of Ericsson/Mitel PABX and PABX systems. I can state that we have been satisfied by there level of professionalism and ability to deliver results on projects.",
    name: "DENIS LABALPINY",
    title: "IT Manager",
    company: "Kinyara Sugar",
    logo: null
  },
  {
    id: 5,
    headline: "They provide carefully and professionally crafted solutions that gave a reassurance that the ICT sector is still worth while to invest in.",
    body: "Voitech Solutions' uniqueness is the ability to first understand the problem statement at hand. Voitech doesn't front technology first but the problem statement first; where they invest a lot of time before designing the final solution",
    name: "ANDREW KIVIRI",
    title: "Managing Director, DotiCom (U) Ltd",
    company: "DotiCom (U) Ltd",
    logo: null
  }
];
